module.exports = __webpack_public_path__ + "static/media/dropdownArrow.673be2ff.svg";